// extracted by mini-css-extract-plugin
export default {"logoContainer":"restaurantLogo_logoContainer__IbLoO","logo":"restaurantLogo_logo__Xoihn"};